import ajax from "@/lib/ajax";

/**
 * 添加话术类型
 * @param {*} params
 */
export function addStatementType(params) {
    return ajax.post("/statement/type/add", params);
}

/**
 * 编辑话术类型
 * @param {*} params
 */
export function updateStatementType(params) {
    return ajax.post("/statement/type/edit", params);
}

/**
 * 删除话术类型
 * @param {*} typeId
 */
export function deleteStatementType(typeId) {
    return ajax.post("/statement/type/delete", { type_id: typeId });
}

/**
 * 获取话术类型列表
 * @param {*} language
 */
export function getStatementTypeList(language) {
    language = language == "all" ? "" : language;
    return ajax.get("statement/type/list", { language });
}

/**
 * 添加话术
 * @param {*} params
 */
export function addStatement(params) {
    return ajax.post("/statement/add", params);
}

/**
 * 编辑话术
 * @param {*} params
 */
export function updateStatement(params) {
    return ajax.post("/statement/edit", params);
}

/**
 * 删除话术
 * @param {*} statementId
 */
export function deleteStatement(statementId) {
    return ajax.post("/statement/delete", { statement_id: statementId });
}

/**
 * 获取话术列表
 * @param {*} language
 */
export function getStatementList(query = {}) {
    query = getQuestionListParams(query);
    const params = Object.assign({ page: 0, perpage: 20 }, query);
    return ajax.get("statement/list", params);
}

// 参数处理
function getQuestionListParams(query) {
    return {
        ...query,
        language: query.language == "all" ? "" : query.language
    };
}
